import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FindDoctorSearchIC.css";

const initSpeciality = [
  "Dentist",
  "Gynecologist/obstetrician",
  "General Physician",
  "Dermatologist",
  "Ear-nose-throat (ent) Specialist",
  "Homeopath",
  "Ayurveda",
];

const FindDoctorSearchIC = () => {
  const [doctorResultHidden, setDoctorResultHidden] = useState(true);
  const [searchDoctor, setSearchDoctor] = useState("");
  const [specialities] = useState(initSpeciality);
  const navigate = useNavigate();

  const handleDoctorSelect = (speciality) => {
    setSearchDoctor(speciality);
    setDoctorResultHidden(true);
    navigate(`/instantconsultation?speciality=${encodeURIComponent(speciality)}`);
  };

  return (
    <div className="finddoctor">
      <h2>Instant consultation — find a doctor now</h2>
      <img
        className="mainimg"
        src="https://img.freepik.com/free-vector/man-with-magnifying-glass-laptop-website-information_24877-53542.jpg?w=800"
        alt="Instant consultation"
      />
      <div className="home-search-container">
        <div className="doctor-search-box">
          <input
            type="text"
            className="search-doctor-input-box"
            placeholder="Search by specialty..."
            onFocus={() => setDoctorResultHidden(false)}
            onBlur={() => setTimeout(() => setDoctorResultHidden(true), 200)}
            value={searchDoctor}
            onChange={(e) => setSearchDoctor(e.target.value)}
          />
          <div className="findiconimg">
            <i className="fa fa-search" />
          </div>
          <div className="search-doctor-input-results" hidden={doctorResultHidden}>
            {specialities.map((speciality) => (
              <div
                className="search-doctor-result-item"
                key={speciality}
                onMouseDown={() => handleDoctorSelect(speciality)}
              >
                <span>
                  <i className="fa fa-search" />
                </span>
                <span>{speciality}</span>
                <span>Speciality</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindDoctorSearchIC;
